<template>
    <div id="email">
        <div class="email_container">
            <b-form ref="form" class="form_item" @submit="onSubmit" @reset="onReset"> 
                <div class="email_item">
                    <div class="label_container">
                        <div id="name_img" class="label_item label_icon"></div>
                        <label class="label_item"> 성함 </label>
                    </div>
                    <b-form-input 
                        type="text" 
                        name="user_name"
                        v-model="form.name"
                        :state="nameState"
                        ref="name_ref"
                    ></b-form-input>
                </div>

                <div class="email_item"> 
                    <div class="label_container">
                        <div id="email_img" class="label_item label_icon"></div>
                        <label class="label_item"> 이메일 </label>
                    </div>
                    <b-form-input 
                        type="email" 
                        v-model="form.email"
                        name="user_email"
                        ref="email_ref"
                    ></b-form-input>
                </div>

                <div class="email_item"> 
                    <div class="label_container">
                        <div id="call_img" class="label_item label_icon"></div>
                        <label class="label_item"> 연락처 </label>
                    </div>
                    <b-form-input 
                        type="text" 
                        v-model="form.call"
                        name="user_call"
                    ></b-form-input>
                </div>

                <div class="email_item"> 
                    <div class="label_container">
                        <div id="message_img" class="label_item label_icon"></div>
                        <label class="label_item"> 내용 </label>
                    </div>
                    <b-form-textarea
                        name="message"
                        v-model="form.message"
                        placeholder="내용을 입력해주세요."
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </div>

                <div class="email_item btn_container">
                    <div class="email_btn btn_item submit" >
                        <input type="submit" value="이메일 보내기">
                    </div>
                    <div class="email_btn reset" >
                        <input type="reset" value="다시쓰기">
                    </div>
                </div>

            </b-form>
        </div>
    </div>
</template>

<script>
    import emailjs from '@emailjs/browser';

    export default {
        computed: {
            nameState() {
                return this.form.name.length > 1 ? true : false
            }
        },
        data() {
            return {
                form : {
                    name: '',
                    email: '',
                    call: '',
                    message: ''
                }
            }
        },
        methods: {
            onSubmit(event) {
                if (this.form.name === '' || this.form.email === '') {
                    if (this.form.name === '') {
                        alert('성함을 확인해주세요.')
                        this.$refs.name_ref.focus()
                        event.preventDefault()

                    } else if (this.form.email === '') {
                        alert('이메일을 확인해주세요.')
                        this.$refs.email_ref.focus()
                        event.preventDefault()
                    }
                } else {
                    event.preventDefault()
                    this.sendEmail()
                }
            },

            onReset(event) {
                event.preventDefault()
                this.form.name = ''
                this.form.email = ''
                this.form.call = ''
                this.form.message = ''
            },

            sendEmail() {
                emailjs.sendForm('service_kslab_gmail', 'template_a4xnujq', this.$refs.form, 'user_QGDhuFGpGw4m0Uu5DV9bS')
                    .then((result) => {
                        alert('이메일을 전송하였습니다.')
                        this.onReset(event)
                        console.log('SUCCESS!', result.text);
                    }, (error) => {
                        alert('이메일 전송을 실패하였습니다.')
                        this.onReset(event)
                        console.log('FAILED...', error.text);
                    });
            }
        }
    }
</script>

<style>

#email {
    text-align: center;
}

#name_img {
  background-image: url(../../public/icon/name.png);
}

#email_img {
  background-image: url(../../public/icon/email.png);
}

#call_img {
  background-image: url(../../public/icon/call.png);
}

#message_img {
  background-image: url(../../public/icon/message.png);
}

.email_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form_item {
    width: 50%;
}

.email_item {
    margin-top: 20px;
    text-align: left;
}

.email_btn {
    text-align: center;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;

    padding-top: 2px;
    width: 130px;
    height: 30px;
    border-radius: 35px;
    border: 1px solid #868686;
    color: #868686;
    
}

.email_btn:hover {
    color: #FFFFFF;
}

.submit:hover {
    border: 1px solid #00C0D6;
    background-color: #00C0D6;
}

.reset:hover {
    border: 1px solid #EA0101;
    background-color: #EA0101;
}

.btn_container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}


</style>